import { render, staticRenderFns } from "./ChangeSchool.vue?vue&type=template&id=4222d02c&scoped=true"
import script from "./ChangeSchool.vue?vue&type=script&lang=js"
export * from "./ChangeSchool.vue?vue&type=script&lang=js"
import style0 from "./ChangeSchool.vue?vue&type=style&index=0&id=4222d02c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4222d02c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4222d02c')) {
      api.createRecord('4222d02c', component.options)
    } else {
      api.reload('4222d02c', component.options)
    }
    module.hot.accept("./ChangeSchool.vue?vue&type=template&id=4222d02c&scoped=true", function () {
      api.rerender('4222d02c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mauser/ChangeSchool.vue"
export default component.exports